import { Text } from '@frameio/vapor';
import type { NotificationGroupInfo } from '../types';
import { Chip } from './Chip';
import { useBodyFragment } from './gql/generated/Body';

export function Body({ id, notificationType }: NotificationGroupInfo) {
  const { complete, data } = useBodyFragment({
    from: { id, __typename: notificationType },
  });

  if (!complete || !('content' in data) || !data?.content?.layout?.body)
    return null;

  const content = data.content.layout.body;

  return (
    <div data-testid="notification-body">
      {content.map((layoutItem, index) => {
        if (!('content' in layoutItem)) return null;

        if (layoutItem.__typename === 'NotificationLayoutItemChip') {
          return (
            <Chip
              key={`${layoutItem.content}-${index}`}
              layoutItem={layoutItem}
            />
          );
        }

        return (
          <Text
            key={`${layoutItem.content}-${index}`}
            color="secondary"
            data-testid="notification-body-text"
            truncate={2}
            variant="primary"
          >
            {layoutItem.content}
          </Text>
        );
      })}
    </div>
  );
}
